const TODO_CHANGE = 'todo_change'

const EVENTLIST = {
  // L-nav监测show-table的变化
  TODO_CHANGE
}
export default {EVENTLIST}



// WEBPACK FOOTER //
// ./src/eventbus/eventlist.js